import PropTypes from 'prop-types';
import React from 'react';
import connectEditElementToBriefStore from 'contest/components/connected/connect-edit-element-to-brief-store';
import { connectReadElement } from 'contest/components/brief/read-element';
import MultipleChoiceDropdown from 'app/components/multiple-choice-dropdown';

export const ViewMultipleChoiceDropdownElement = ({ text }) => <p>{text}</p>;

ViewMultipleChoiceDropdownElement.propTypes = {
    text: PropTypes.string.isRequired,
};

export const ConnectedViewMultipleChoiceDropdownElement = connectReadElement(
    ViewMultipleChoiceDropdownElement,
    element => {
        const labels = element.value.map(item => {
            if (element.trans.choices.hasOwnProperty(item)) {
                return element.trans.choices[item];
            } else {
                return item;
            }
        });

        return { text: labels.join(', ') };
    },
    ({ value }) => value.length
);

export class EditMultipleChoiceDropdownElement extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(selectedArray) {
        const value = selectedArray.map(item => {
            return item.value;
        });

        this.props.onChange(value, true);
    }

    buildOptions() {
        const options = Object.keys(this.props.choices).map(key => {
            return {
                label: this.props.choices[key],
                value: key,
            };
        });

        this.props.value.forEach(option => {
            if (!this.props.choices.hasOwnProperty(option)) {
                options.push({
                    label: option,
                    value: option,
                });
            }
        });

        return options;
    }

    render() {
        return (
            <MultipleChoiceDropdown
                className="Select--fullwidth"
                options={this.buildOptions()}
                initialValue={this.props.value}
                placeholder={this.props.placeholder}
                createOptionLabel={this.props.createOptionLabel}
                onChange={this.handleChange}
            />
        );
    }
}

EditMultipleChoiceDropdownElement.propTypes = {
    value: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    choices: PropTypes.object.isRequired,
    placeholder: PropTypes.string,
    createOptionLabel: PropTypes.string,
};

EditMultipleChoiceDropdownElement.defaultProps = {
    placeholder: '',
    createOptionLabel: '',
};

export const ConnectedEditMultipleChoiceDropdownElement = connectEditElementToBriefStore(
    EditMultipleChoiceDropdownElement,
    element => ({
        value: element.value,
        choices: element.trans.choices,
        placeholder: element.trans.placeholder,
        createOptionLabel: element.trans.createOptionLabel,
    })
);



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/multiple-choice-dropdown-element.jsx